import { useMutation as reactMutation } from 'react-query'

const useMutation = (queryFunction, options) => {
  const { mutate, mutateAsync, error: errorMutation } = reactMutation(queryFunction, options)
  const error = errorMutation?.response?.data
  return { mutate, mutateAsync, error }
}

export default useMutation
